<div class="xenial-stores-tab">
        <div class="messages">
            <txp-message
                class="message"
                [type]="messageType.WARNING"
                *ngIf="showNoPriceMsg"
                data-qa-label="NoPriceMsg">
                {{ 'catalog.common.xenialDetails.requiredPrice' | translate }}
            </txp-message>

            <txp-message
                class="message"
                [type]="messageType.WARNING"
                *ngIf="showNoStoresMsg"
                data-qa-label="NoStoresMsg">
                {{ 'catalog.common.xenialDetails.emptyStoresMsg' | translate }}
            </txp-message>

            <txp-message
                class="message"
                [type]="messageType.WARNING"
                *ngIf="showNoAvailabilityMsg"
                data-qa-label="NoAvailabilityMsg">
                {{ 'catalog.common.xenialDetails.availability' | translate }}
            </txp-message>

            <txp-message
                class="message"
                [type]="messageType.WARNING"
                *ngIf="showNoDataGroupIdMsg"
                data-qa-label="NoDataGroupIdMsg">
                {{ 'catalog.common.xenialDetails.missingDataGroupId' | translate }}
            </txp-message>

            <txp-message
                class="message"
                [type]="messageType.WARNING"
                *ngIf="showNoPosAssociationWarning"
                data-qa-label="NoPosAssociationMsg">
                {{ 'catalog.common.xenialDetails.missingPosAssociation' | translate }}
            </txp-message>
        </div>

    <div class="xenial-stores-header">
        <div class="manage-stores-label">
            {{ 'catalog.common.xenialDetails.storesTab' | translate }}
        </div>
        <txp-button
            [style]="buttonStyle.SECONDARY"
            class="add-stores-button"
            (click)="onAddStore()"
            [disabled]="showNoDataGroupIdMsg"
            data-qa-label="AddStoresButton">
            {{ 'catalog.common.xenialDetails.addStore' | translate }}
        </txp-button>
    </div>

    <div class="xenial-stores-table-wrapper" [formGroup]="form">
        <ng-container *ngIf="storesFormArray && storesFormArray.length > 0">
            <table
                mat-table
                [dataSource]="storesFormArray.controls"
                class="mat-elevation-z0"
                multiTemplateDataRows
                formArrayName="stores">

                <!-- Store Number Column (displayed) -->
                <ng-container matColumnDef="storeNumber">
                    <th mat-header-cell *matHeaderCellDef>
                         {{ 'catalog.common.xenialDetails.storeNumber' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let store">
                        {{ store.get('storeNumber')?.value }}
                    </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef>
                        {{ 'catalog.common.xenialDetails.storeName' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let store">
                        {{ store.get('name')?.value }}
                    </td>
                </ng-container>

                <!-- Store Price Column -->
                <ng-container matColumnDef="price">
                    <th mat-header-cell *matHeaderCellDef>
                        Store Price
                    </th>
                    <td mat-cell *matCellDef="let store; let i = index">
                        <mat-form-field appearance="outline" style="width: 200px;">
                            <input
                                matInput
                                type="number"
                                [formControl]="store.get('price')"
                                min="0"
                                [ngClass]="{'mat-input-invalid': store.get('price')?.hasError('required') && formSubmitted}" />
                            <mat-error *ngIf="store.get('price')?.hasError('required') && formSubmitted">
                                {{ 'catalog.common.xenialDetails.requiredPrice' | translate }}
                            </mat-error>
                        </mat-form-field>
                    </td>
                </ng-container>

                <!-- Available Column -->
                <ng-container matColumnDef="available">
                    <th mat-header-cell *matHeaderCellDef>
                        Available
                    </th>
                    <td mat-cell *matCellDef="let store; let i = index">
                        <mat-slide-toggle [formControl]="store.get('available')" color="primary">
                        </mat-slide-toggle>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </ng-container>
    </div>
</div>